export const routes = {
  home: "/",
  scratchathon: "/scratchathon",
  about: "/#about",
  team: "/#team",
  contact: "/#contact",
  learnscratch: "/learnscratch",
  external: {
    projectID: "#",
  },
};
